<template>
  <div id="grid-visita">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-content: center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Region"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            :items="comunaSelect"
            label="Comuna"
            item-text="nombre"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="rbdValue"
            :items="rbdSelect"
            label="RBD"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo de Prueba"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
            data-vv-name="listaNiveles"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="estadoValue"
            :items="estadoSelect"
            label="Estado"
            data-vv-name="listaNiveles"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar contratos"
          @click="filterVisit()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="visitas"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.salCursoId.region }}</td>
              <td class="text-xs-left">{{ props.item.salCursoId.comuna }}</td>
              <td class="text-xs-left">{{ props.item.salCursoId.rbd }}</td>
              <td class="text-xs-left">
                {{ props.item.salCursoId.tipoPrueba }}
              </td>
              <td class="text-xs-left">{{ props.item.salCursoId.nivel }}</td>
              <td class="text-xs-left">{{ props.item.salCursoId.letra }}</td>
              <td class="text-xs-left">
                {{
                  props.item.estado_visitaPreviaId != null
                    ? props.item.estado_visitaPreviaId.descripcion
                    : "-"
                }}
              </td>
              <td class="text-xs-left">{{ props.item.fechaVista_real }}</td>
              <td>
                <v-btn
                  v-if="
                    (usuarioLoggedTipe == 'PROVEEDOR' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    (props.item.fechaVista_real == null ||
                      props.item.fechaVista_real == '' ||
                      props.item.fechaVista_real == undefined)
                  "
                  class="btn-sigas"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="light-green darken-4"
                  small
                  title="Registrar Visita"
                  @click="editVisita(props.item.id)"
                >
                  <v-icon>event</v-icon>
                </v-btn>
                <v-btn
                  class="btn-sigas"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="light-green"
                  small
                  title="Ver Visita Realizada"
                  @click="viewVisitaReal(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA VISITAS -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template
                  v-if="
                    usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR'
                  "
                >
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-green darken-4"
                    small
                  >
                    <v-icon>event</v-icon> </v-btn
                  >&nbsp;Registrar visita
                </template>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-green"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar visita realizada
                </template>
              </td>
            </div>
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-flex>
        <v-btn color="primary" @click="descargaMasiva()"
          >Descarga Visitas</v-btn
        >
      </v-flex>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "grid-visita",
  components: {
    LoadingDescarga,
    Loading,
  },
  props: {},
  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      contratoId: "",
      allowSpaces: false,
      visitas: [],
      filter: false,
      visitaGrid: 0,
      regionSelect: [],
      regionValue: null,
      comunaSelect: [],
      comunaValue: null,
      rbdSelect: [],
      rbdValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      nivelSelect: [],
      nivelValue: null,
      estadoSelect: [],
      estadoValue: null,
      dialogLoading: false,
      loading: false,
      dialog: false,
      menu1: false,
      idVisitaUpdate: "",
      headers: [
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Letra", sortable: false, value: "letra" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha Visita Realizada", sortable: false, value: "fechapre" },
        { text: "Acciones visitas", sortable: false, value: "" },
      ],
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
      this.loadData();
    } else {
      //this.loadDataVisitas();
    }
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadVisitasFilter() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        rbd: this.rbdValue && this.rbdValue != null ? this.rbdValue : null,
        tipoPrueba:
          this.tipoPruebaValue && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        estado:
          this.estadoValue && this.estadoValue != null
            ? this.estadoValue
            : null,
      };
      return await axios
        .post("/visitaAplicacion/visitaPreviaFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    submit() {
      this.$v.$touch();
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.rbdValue = "";
      this.tipoPruebaValue = "";
      this.nivelValue = "";
      this.estadoValue = "";
      this.loadData();
    },
    filterVisit() {
      this.loadData();
    },

    async loadData() {
      this.loading = true;
      this.visitas = await this.loadVisitasFilter();
      this.miPaginacion.totalItems = this.visitas.length;
      if (this.visitas.length > 0) {
        this.loadRegionSelect();
        this.loadRbdSelect();
        this.loadComuna();
        this.loadPruebaSelect();
        this.loadNivelSelect();
        this.loadEstadoSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.visitas.forEach(function (d) {
        let index = niv.findIndex((x) => x.nivel == d.salCursoId.nivel);
        if (index === -1) {
          niv.push(d.salCursoId.nivel);
        }
      });
      this.nivelSelect = niv;
    },
    loadEstadoSelect() {
      let est = [];
      this.visitas.forEach(function (d) {
        let index = est.findIndex(
          (x) => x.estado == d.estado_visitaPreviaId.descripcion
        );
        if (index === -1) {
          est.push(d.estado_visitaPreviaId.descripcion);
        }
      });
      this.estadoSelect = est;
    },
    loadPruebaSelect() {
      let tip = [];
      this.visitas.forEach(function (d) {
        let index = tip.findIndex(
          (x) => x.tipoPrueba == d.salCursoId.tipoPrueba
        );
        if (index === -1) {
          tip.push(d.salCursoId.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    loadRegionSelect() {
      let reg = [];
      this.visitas.forEach(function (d) {
        if (d.salCursoId.region != null) {
          let index = reg.findIndex((x) => x.code == d.salCursoId.idRegion);
          if (index === -1) {
            if (d.salCursoId.idRegion != null && d.salCursoId.idRegion != "") {
              reg.push({
                name: d.salCursoId.region,
                code: d.salCursoId.idRegion,
              });
            }
          }
        }
      });
      this.regionSelect = reg;
    },
    loadComuna() {
      let rc = [];
      this.visitas.forEach(function (d) {
        let index = rc.findIndex((x) => x.comuna == d.salCursoId.comuna);
        if (index === -1) {
          if (d.salCursoId.comuna != null && d.salCursoId.comuna != "") {
            rc.push(d.salCursoId.comuna);
          }
        }
      });
      this.comunaSelect = rc;
    },
    loadRbdSelect() {
      let rbd = [];
      this.visitas.forEach(function (d) {
        let index = rbd.findIndex((x) => x.rbd == d.salCursoId.rbd);
        if (index === -1) {
          rbd.push(d.salCursoId.rbd);
        }
      });
      this.rbdSelect = rbd;
    },
    reloadVisitas() {
      this.visitaGrid += 1;
    },

    newVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },

    viewVisitaPre(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "consultaPrevista" },
        });
      }, 1000);
    },
    viewVisitaReal(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "consultaRealizada" },
        });
      }, 1000);
    },
    editVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistraAplicacion",
          params: { id: id, tipeView: "modificaVisita" },
        });
      }, 1000);
    },
    reloadGrid() {
      this.dialog = false;
      this.$parent.reloadVisitas();
    },
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    editFecha(id) {
      this.dialog = true;
      this.idVisitaUpdate = id;
    },
    descargaMasiva() {
      this.dialogLoading = true;
      axios
        .get("/visitaAplicacion/downloadExcelVisitaPrev/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_MASIVA_VUSUTA.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
